import React from 'react';
import { getConnectedPoints } from '../utils/pathCalculations';
import '../../styles/modes/customMode.css';

const AvailablePoints = ({ customPath, availablePoints, selectNextPoint, pathComplete, connections, demand, modeCapacities }) => {
  // Only show if path is not complete and there are points in the path
  if (pathComplete || customPath.length === 0) {
    return null;
  }
  
  const connectedPoints = getConnectedPoints(availablePoints, customPath, connections || []);
  const lastPoint = customPath[customPath.length - 1];
  
  // Find connection details for each available point
  const getSegmentInfo = (nextPoint) => {
    const connection = connections.find(conn => 
      (conn.points[0]?.id === lastPoint.id && conn.points[1]?.id === nextPoint.id) ||
      (conn.points[1]?.id === lastPoint.id && conn.points[0]?.id === nextPoint.id)
    );
    
    if (!connection) return null;
    
    const capacity = modeCapacities[connection.transportMode] || 0;
    const duration = connection.duration || 0;
    const tripsNeeded = (demand > 0 && capacity > 0) ? Math.ceil(demand / capacity) : 0;
    const totalTime = duration * (tripsNeeded || 1);
    
    return {
      transport_mode: connection.transportMode,
      duration,
      capacity,
      tripsNeeded,
      totalTime
    };
  };
  
  return (
    <div className="available-points">
      <h5>Select Next Location Point</h5>
      <div className="available-points-list">
        {connectedPoints.length > 0 ? (
          connectedPoints.map(point => {
            const segmentInfo = getSegmentInfo(point);
            
            return (
              <div 
                key={`available-${point.id}-${Math.random().toString(36).substr(2, 9)}`}
                className="next-point-preview-card"
                onClick={() => selectNextPoint(point)}
              >
                {demand > 0 ? (
                  // Capacity mode: Two-line display with full details
                  <>
                    <div className="preview-header">
                      <span className="preview-route">{lastPoint.name} → {point.name}</span>
                      {segmentInfo && (
                        <span className="transport-mode-badge-small">{segmentInfo.transport_mode}</span>
                      )}
                    </div>
                    
                    {segmentInfo ? (
                      <div className="segment-info-grid-preview">
                        <div className="info-item">
                          <span className="info-label">Single Trip Time:</span>
                          <span className="info-value">{segmentInfo.duration}h</span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">Trips Needed:</span>
                          <span className="info-value">{segmentInfo.capacity > 0 ? segmentInfo.tripsNeeded : 'Set capacity'}</span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">Segment Total Time:</span>
                          <span className="info-value-highlight">{segmentInfo.capacity > 0 ? `${segmentInfo.totalTime}h` : 'N/A'}</span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">Capacity per Trip:</span>
                          <span className="info-value">{segmentInfo.capacity > 0 ? `${segmentInfo.capacity} units` : 'Not set'}</span>
                        </div>
                      </div>
                    ) : (
                      <div className="preview-info">
                        <span className="preview-warning">No connection data</span>
                      </div>
                    )}
                  </>
                ) : (
                  // Standard mode: Single-line display
                  <div className="preview-single-line">
                    <span className="preview-route-inline">{lastPoint.name} → {point.name}</span>
                    {segmentInfo && (
                      <>
                        <span className="transport-mode-badge-small">{segmentInfo.transport_mode}</span>
                        <span className="preview-detail-inline">Duration: {segmentInfo.duration}h</span>
                      </>
                    )}
                    {!segmentInfo && (
                      <span className="preview-warning">No connection</span>
                    )}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="no-connected-points">
            <p>No connected points available.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AvailablePoints;
